import { Link } from "@/components/common/Link";

// 1. Componente de botón reutilizable
function MoreInfoButton({
  className = ""
}: {
  className?: string;
}) {
  return <Link to="#" className={`inline-flex items-center gap-2 bg-[#353533] text-white font-['Switzer',sans-serif] text-sm font-medium leading-[21px] uppercase rounded-full py-1 pl-3 pr-1 border border-[#353533] hover:opacity-85 transition-opacity ${className}`}>
      MÁS INFORMACIÓN
      <span className="w-7 h-7 bg-[#353533] border-[1.5px] border-white/40 rounded-full flex items-center justify-center">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 11L11 3M11 3H5M11 3V9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </Link>;
}

// 3. Tarjeta individual optimizada
function MinistryCard({
  title,
  imageUrl
}: {
  title: string;
  imageUrl: string;
}) {
  return <div className="group relative rounded-[20px] overflow-hidden h-[420px] cursor-pointer shadow-sm">
      {/* Imagen con efecto Hover */}
      <img src={imageUrl} alt={title} loading="lazy" className="w-full h-full object-cover block transition-transform duration-500 ease-in-out group-hover:scale-105" />

      {/* Botón flecha superior */}
      <button type="button" aria-label={`Ver más sobre ${title}`} className="absolute top-5 right-5 w-10 h-10 bg-white rounded-full border-none flex items-center justify-center cursor-pointer transition-colors duration-200 hover:bg-gray-100 z-10 shadow-md">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.5 12.5L12.5 3.5M12.5 3.5H5.5M12.5 3.5V10.5" stroke="#212529" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* Tarjeta de información inferior */}
      <div className="absolute bottom-0 left-0 bg-white rounded-tr-[20px] p-5 md:p-6 z-10 max-w-[85%]">
        <h2 className="text-[#212529] text-xl md:text-[26px] font-normal leading-tight uppercase m-0 mb-3">
          {title}
        </h2>
        <MoreInfoButton />
      </div>
    </div>;
}

// 2. Componente principal exportado por defecto
export default function DiscoverMinistriesSection() {
  return <section className="bg-[#F5F4F2] py-16 md:py-24 font-['Switzer',sans-serif] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Encabezado */}
        <div className="text-center mb-16 md:mb-24">
          <h1 className="text-[#21211F] text-3xl sm:text-4xl md:text-5xl font-normal leading-tight uppercase flex items-center justify-center flex-wrap gap-2 md:gap-3 mb-6">
            DESCUBRE LOS
            <span className="relative inline-flex items-center">
              <span className="text-white rounded-full px-4 md:px-5 py-0.5 bg-gradient-to-r from-[#018BB9] to-[#34499A]">
                MINISTERIOS
              </span>
              <span className="absolute -top-3 -right-3 md:-top-4 md:-right-4 w-6 h-6 md:w-8 md:h-8 flex items-center justify-center">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/star_dark.svg" alt="Estrella decorativa" className="w-full h-full" />
              </span>
            </span>
          </h1>

          <p className="text-[#21211F] text-base md:text-xl font-light leading-6 md:leading-7 mb-8 max-w-2xl mx-auto px-2">
            Los Ministerios de Asambleas de Dios equipan a niños, jóvenes, adultos, familias y líderes para vivir vidas empoderadas por el Espíritu.
          </p>

          <MoreInfoButton />
        </div>

        {/* Grid de Tarjetas */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <MinistryCard title="LÍDERES Y MINISTROS" imageUrl="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Ministry_Leaders.jpg" />
          <MinistryCard title="ADULTOS Y FAMILIAS" imageUrl="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Ministry_Adult-Family.jpg" />
          <MinistryCard title="JÓVENES" imageUrl="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Ministry_Youth.jpg" />
          <MinistryCard title="NIÑOS" imageUrl="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Ministry_Children.jpg" />
        </div>
      </div>
    </section>;
}